import Loading from "../loading";
import styles from "./index.module.scss";
import { CloseSvg, CorrectSvg } from "@/assets/icons";

type ModalHeaderMobileProps = {
  title: string;
  loading?: boolean;
  onClose?: () => void;
  onConfirm: () => void;
}

const ModalHeaderMobile = (props: ModalHeaderMobileProps) => {
  const {
    title,
    loading = false,
    onClose,
    onConfirm,
  } = props;

  return (
    <div
      className={styles["modal_header_mobile"]}
    >
      <button
        className={styles["close_button"]}
        onClick={onClose}
      >
        <CloseSvg></CloseSvg>
      </button>

      <span
        className={styles["title"]}
      >
        {title}
      </span>

      {loading ? (
        <Loading
          className={styles["custom_loading"]}
          isBlack
        ></Loading>
      ) : (
        <button
          className={styles["select_button"]}
          onClick={onConfirm}
        >
          <CorrectSvg></CorrectSvg>
        </button>
      )}
    </div>
  )
}

export default ModalHeaderMobile;